
// material-ui
import { styled, Theme } from '@mui/material/styles';
import MuiAvatar from '@mui/material/Avatar';

// project imports
import getColors from '../../utils/getColors';

// types
import { AvatarProps } from '../../types/components';

interface GetColorStyleProps {
  theme: Theme;
  color: string;
  type: string;
}

function getColorStyle({ theme, color, type }: GetColorStyleProps) {
  const colors: any = getColors(theme, color);
  const { lighter, light, main, contrastText } = colors;

  switch (type) {
    case 'filled':
      return {
        color: contrastText,
        background: main
      };
    case 'outlined':
      return {
        color: main,
        border: '1px solid',
        borderColor: main,
        background: 'transparent'
      };
    case 'combined':
      return {
        color: main,
        border: '1px solid',
        borderColor: light,
        background: lighter
      };
    default:
      return {
        color: main,
        background: lighter
      };
  }
}

// ==============================|| AVATAR - SIZE STYLE ||============================== //

function getSizeStyle(size: string) {
  switch (size) {
    case 'badge':
      return {
        border: '2px solid',
        fontSize: '0.675rem',
        width: 20,
        height: 20
      };
    case 'xs':
      return {
        fontSize: '0.75rem',
        width: 24,
        height: 24
      };
    case 'sm':
      return {
        fontSize: '0.875rem',
        width: 32,
        height: 32
      };
    case 'lg':
      return {
        fontSize: '1.2rem',
        width: 52,
        height: 52
      };
    case 'xl':
      return {
        fontSize: '1.5rem',
        width: 64,
        height: 64
      };
    case 'md':
    default:
      return {
        fontSize: '1rem',
        width: 40,
        height: 40
      };
  }
}

const AvatarStyle = styled(MuiAvatar, { shouldForwardProp: (prop: string) => prop !== 'color' && prop !== 'type' && prop !== 'size' && prop !== 'variant' })(
  ({ theme, size, color, type, variant }: { theme: Theme; size: string; color: string; type: string; variant?: 'circular' | 'rounded' | 'square' }) => ({
    ...getSizeStyle(size),
    ...getColorStyle({ theme, color, type }),
    variants: [
      {
        props: { size: 'badge' },
        style: {
          borderColor: theme.palette.background.default
        }
      }
    ]
  })
);

const Avatar: React.FC<AvatarProps> = ({ children, color = 'primary', outline = false, size = 'md', variant = 'circular', sx, ...others }) => {
  return (
    <AvatarStyle color={color} type={outline ? 'outlined' : 'filled'} size={size} variant={variant} sx={sx} {...others}>
      {children}
    </AvatarStyle>
  );
};

export default Avatar;

// Removed legacy propTypes (deprecated in TS projects)


